import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  fieldContent: {
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
  },
  imageWrapper: {
    width: '100%',
    aspectRatio: '16 / 9',
    overflow: 'hidden',
    display: 'block',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  link: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.secondary.main
        : theme.palette.primary.main,
    textDecoration: 'none',
  },
}));
